import React from 'react';
import './About.css';
import collectionImage from '../images/collection.png';

export default function About() {
  return (
    <section className="about">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-6 about-image">
            <img src={collectionImage} className="img-fluid" alt="Collection" />
          </div>
          <div className="col-md-6 panel-content">
            <h3 className="about-title">SOUR PUPS<br />
              <span>COLLECTABLES</span>
            </h3>
            <p className="about-content">Step into a realm where imagination intertwines with history.</p>
            <p className="about-content">Sour Pups is a captivating NFT collection that draws inspiration from cute pups. Throughout our collection, you’ll discover elements reminiscent of adorable pups</p>
            <div className="row justify-content-around">
              <Card title="Breads" value="20" />
              <Card title="Category" value="Cute" />
              <Card title="Collection Size" value="500" />
            </div>
          </div>

          <div className="row justify-content-center boxs">
            <div className="col-md-3">
              <div className="box">
                <i className="bi bi-back"></i>
                <h2>20+</h2>
                <p>Backgrounds</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box">
                <i className="bi bi-person-lines-fill"></i>
                <h2>30+</h2>
                <p>Armor Variations</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box">
                <i className="bi bi-person-bounding-box"></i>
                <h2>30</h2>
                <p>Breads</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="box">
                <i className="bi bi-magic"></i>
                <h2>30</h2>
                <p>Unique Item</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Card = ({ title, value }) => {
  return (
    <div className="col-md-3 about-card">
      <h2>{value}</h2>
      <p>{title}</p>
    </div>
  );
};


